import { render, staticRenderFns } from "./ShortVideo.vue?vue&type=template&id=2afec858&scoped=true"
import script from "./ShortVideo.vue?vue&type=script&lang=js"
export * from "./ShortVideo.vue?vue&type=script&lang=js"
import style0 from "./ShortVideo.vue?vue&type=style&index=0&id=2afec858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afec858",
  null
  
)

export default component.exports